/**
 * Authors: mariushirjanu
 * Created: 06/11/2020
 */
import { Injectable } from '@angular/core';

import { HttpDataService } from '../../../shared/http/http-data.service';
import { ICodeValue, IContact, ICurrency, ILocationExtended } from '../../../../type_definitions/datatypes';
import { IExternalPartnerRelation } from '../webshop.service';

export interface IWebshopBillingData {
  webshopId:number;

  defaultBillingType:ICodeValue;
  changeBillingType:boolean;
  centralBillingInvoiceAddress:ILocationExtended;
  centralBillingInvoiceEmailAddress:string;
  invoiceCurrency:ICurrency;
  centralBillingInvoiceContact:IContact;
  centralBillingContractId:number;
  invoiceInstructions:string;
  localBillingInvoiceEmailAddress:string;

  totalInvoiceAddresses:number;
  invoiceAddressFixedList:boolean;
  invoiceAllowLAMAddress:boolean;
  invoiceAllowSameLocation:boolean;
  invoiceAllowSearchLocation:boolean;
  invoiceAllowOneTimeAddress:boolean;

  invoiceCompliance:boolean;
  bpInvoiceMandatory:boolean;
  invoiceBeforeShips:boolean;

  paymentTypePO:boolean;
  paymentTypeCC:boolean;
  paymentTypeCCPct:number;
  ccStatusClearing:ICodeValue;
  defaultPaymentType:ICodeValue;

  defaultProcurementType:ICodeValue;
  procurementTypeBuy:boolean;
  procurementTypeLease:boolean;
  totalLeasingAddresses:number;
  totalLeasingAddressesMissingInfo:number;

  totalB2BSetupTickets:number;
  totalB2BInvoiceMessages:number;
  b2bSurveyQuestion:string;
  b2bSurveyAnswer:string;

  chargebackActivated:boolean;
  chargebackMargin:string;
  chargebackMarginType:string;

  batchBilling:boolean;
  batchBillingPerCountry:boolean;
  batchBillingMargin?:string;
  batchBillingCutOffDates:number;
  batchBillingMaximumPT:number;
  batchBillingDefaultPT:number;
  defaultPTExceedsMaxPT:boolean;

  totalOpenInvoices:number;

  spendLimit:number;
  spendLimitCurrency:string;
  spendLimitStartDate:Date;

  centralBillingPaymentTerms:number;
  extendedPaymentTermsPct?: string;
  extendedPaymentTermsDays?: number;
  localBillingPTLink?: string;
  hideProcurementPriceForCustomer?:boolean;

  lessorRelations?: IExternalPartnerRelation[];
  invoicePlatformRelations?: IExternalPartnerRelation[];

  orderSummaryInOrderNotification:boolean;
  billingStatementInOrderNotification:boolean;
}

@Injectable()
export class WebshopBillingDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    //empty
  }

  public getWebshopBillingData(webshopId:number):Promise<IWebshopBillingData> {
    return this.httpDataService.doGET(
      `rest/webshops/${webshopId}/billing`,
      {},
      undefined,
      'Error loading webshops billing'
    );
  }

  public saveWebshopBillingData(webshopId:number, data:IWebshopBillingData):Promise<IWebshopBillingData> {
    return this.httpDataService.doPUT(
      `rest/webshops/${webshopId}/billing`,
      undefined,
      data,
      'Saving webshop billing',
      'Error saving webshop billing'
    );
  }

  public getWebshopInvoiceLocations(webshopId:number):Promise<ILocationExtended[]> {
    return this.httpDataService.doGET(
      `rest/webshops/${webshopId}/invoicelocations`,
      {},
      undefined,
      'Error loading webshops locations'
    );
  }

  public getWebshopInvoiceContacts(webshopId:number, invoiceLocationId:number):Promise<IContact[]> {
    return this.httpDataService.doGET(
      `rest/webshops/${webshopId}/invoicelocations/${invoiceLocationId}/invoicecontacts`,
      {},
      undefined,
      'Error loading location contacts'
    );
  }
}